import script from "./CommandModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CommandModal.vue?vue&type=script&setup=true&lang=js"

import "./CommandModal.vue?vue&type=style&index=0&id=588ad41e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-588ad41e"]])

export default __exports__